import React, { useState } from "react";
import { type AuthResponseDto } from "../../../../../api/api";
import { VerifyOtpForm } from "../verify-otp-form";
import { showErrorToast, showSuccessToast } from "../../../../../utils/toasts";
import { handleAxiosError } from "../../../../../common/error_handling";
import { PhoneInput } from "../../../../../components/common/input";
import { Button } from "../../../../../components/common/button";
import { Text } from "../../../../../components/common/typography";
import { authSession } from "../../../../../modules/authentication/token_store";
import { useMe } from "../../../../../swr";
import { useOTP } from "../../../../../common/hooks/useOtp";
import { authOtpService } from "../../../../api_client";
import { useLocation, useNavigate } from "react-router-dom";
import { dashboardRouteForRole, resolvePostLoginRedirect } from "../../../utils/post-login-redirect";

export const OtpLoginSection: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mutate } = useMe();
  const [otpSent, setOtpSent] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const { isResendDisabled, countdown, resetCountdown } = useOTP();

  if (otpSent) {
    return (
      <div className="flex w-full flex-col gap-4">
        <Text variant="body" tone="body" className="text-center">
          Enter the verification code we just sent you.
        </Text>
        <VerifyOtpForm<AuthResponseDto>
          phoneNumber={phoneNumber}
          onSuccess={async (resp) => {
            authSession.setAccessToken(resp.accessToken);
            const updated = await mutate();
            showSuccessToast("Login successful!");
            navigate(resolvePostLoginRedirect(location, dashboardRouteForRole(updated?.role)));
          }}
          confirmOtpMethod={async (otp, phoneNumber) => {
            return await authOtpService.otpLoginVerify({
              phoneNumber,
              otp,
            });
          }}
          isResendDisabled={isResendDisabled}
          countdown={countdown}
          onResend={async () => {
            await authOtpService.otpLoginRequest({
              phoneNumber,
            });
          }}
          buttonText="Verify & Continue"
        />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-6">
      <PhoneInput
        name="phoneNumber"
        label="Phone number"
        required
        value={phoneNumber}
        onChange={setPhoneNumber}
      />
      <Button
        variant="primary"
        fullWidth
        onClick={async () => {
          if (!phoneNumber) {
            showErrorToast("Please enter your email or phone");
            return;
          }
          try {
            await authOtpService.otpLoginRequest({ phoneNumber });
            resetCountdown();
            setOtpSent(true);
            showSuccessToast("OTP sent. Check your inbox/messages.");
          } catch (error) {
            const message = handleAxiosError(error).message;
            showErrorToast(message);
          }
        }}
      >
        Continue
      </Button>
    </div>
  );
};

export default OtpLoginSection;
